import { get, post } from "../client";
import { GET_INVOICES, SEND_INVOICES } from "../routes";

export default {
  get_invoices: async () => await get(GET_INVOICES),

  send_invoice: async (data) => await post(SEND_INVOICES, data),
};
